import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Bar, BarDivider, BarNav, BarNavLink, BarNavPosition, Icon, Modal } from '@abb/common-ux';
import { BannerContainer } from '@module/shared/components/BannerContainer';
import { DefaultText } from '@module/shared/components/Layout';
import { PermissionConstants } from '@module/shared/models/models';
import { IEHelper } from '@util/IEHelper';
import { IConnectedComponent } from 'reducers';
import './Layout.scss';

interface ILayoutState {
  helpToggled: boolean;
  userIsIdle: boolean;
  timeout: number;
}

const initialActivityTimeOut = 20 * 60000;
const acitivtyTimeoutWarning = 2 * 60000;
export class LayoutComponent extends React.Component<IConnectedComponent, ILayoutState> {
  idleTimer: IdleTimer | null;

  constructor(props: IConnectedComponent) {
    super(props);
    this.state = {
      helpToggled: false,
      userIsIdle: false,
      timeout: initialActivityTimeOut
    };
  }

  stopEventPropogation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.nativeEvent.stopImmediatePropagation();
  }

  toggleHelp = (e: any) => {
    this.props.dispatch({ type: 'BANNER_CLEAR'});
    this.stopEventPropogation(e);
    this.setState({helpToggled: !this.state.helpToggled});
  }

  displayText = (page: string) => {
    return (<DefaultText />);
  }

  dismiss = () => {
    this.setState({ helpToggled: false });
  }  

  componentWillMount() {
    this.props.dispatch({ type: 'BANNER_CLEAR' });
  }
  
  componentDidMount() {
    window.addEventListener('click', this.dismiss);
    if (!this.props.loggedInUser && (this.props.location.pathname === '/' || this.props.location.pathname === '/requests')) {
      IEHelper.displayBanner(this.props.dispatch);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.dismiss);
  }  

  handleOnIdle = () => {
    if (this.props.loggedInUser) {
      if (this.state.userIsIdle) {
        this.setState({ timeout: initialActivityTimeOut });
        this.props.history.push('/logout');
      } else {
        this.setState({ userIsIdle: true, timeout: acitivtyTimeoutWarning }, () => {
          if (this.idleTimer) {
            this.idleTimer.reset();
          }
        });
      }
    }
  }

  handleOnAction = () => {
    if (this.state.userIsIdle === true) {
      this.setState({ userIsIdle: false, timeout: initialActivityTimeOut });
    }
  }

  hasValidPermissions = () => {
    return this.props.loggedInUser && 
      this.props.userPermissions &&
      this.props.userPermissions.permissions &&
      this.props.userPermissions.permissions.some(p => p.code === PermissionConstants.ManagePartInventory || p.code === PermissionConstants.AdministerPartInventory);
  }

  render() {
    let userBarNav = this.props.location.pathname.toLowerCase() === '/logout' || this.props.location.pathname.toLowerCase().substring(0, 9) === '/requests' ? (
      <BarNav position={BarNavPosition.Right}>        
        <BarNavLink to='/Login'>Log In</BarNavLink>
      </BarNav>
    ) : '';
    const requestBarNav = this.props.location.pathname.toLowerCase().substring(0, 9) === '/requests' || this.props.location.pathname.toLowerCase().substring(0, 9).includes('/logout') || this.hasValidPermissions() ? (
      <BarNav position={BarNavPosition.Left}>
        <BarNavLink to={{ pathname: '/requests', state: { fromRequestLogDetails: true} }}>Requests</BarNavLink>
        <BarDivider orientation='vertical' />
      </BarNav>
    ) : '';

    if (this.props.loggedInUser) {
      const profile = this.props.loggedInUser.profile;
      userBarNav = (
        <BarNav position={BarNavPosition.Right}>
          <BarDivider orientation='vertical' />
          <BarNav>
            <div className='parentAlign'>
              <div className={this.state.helpToggled ? 'help' : 'nohelp'} onClick={this.stopEventPropogation}>
                {this.displayText(this.props.location.pathname)}
              </div>
            </div>
          </BarNav>
          <BarNavLink onClick={this.toggleHelp} to='#'>
            <Icon icon='help_circle1' /> Help
          </BarNavLink>
          <BarDivider orientation='vertical' />
          <p className='navbar-text'>
            <Icon icon='user' /> {profile.name}
          </p>
          <BarDivider orientation='vertical' />
          <BarNavLink to='/Logout'>
            <Icon icon='log_out' />
          </BarNavLink>
        </BarNav>
      );
    }
    return (
      <IdleTimer 
      ref={ref => { this.idleTimer = ref; }}
      timeout={this.state.timeout}
      onIdle={this.handleOnIdle}
      onAction={this.handleOnAction}
      debounce={250}
      events={['click', 'keypress', 'mousemove']}
    >
      <Modal
        isOpen={this.props.loggedInUser && this.state.userIsIdle}
        header={`Inactivity Detection`}
        modalClassName='inactivityModal'
      >
        You have been inactive for {initialActivityTimeOut / 60000} minutes. For security purposes you will be automatically logged out in {acitivtyTimeoutWarning / 60000} minutes. 
        <br/><br/>
        Click anywhere or press any key to stay logged in.
      </Modal>
      <div>
        <Bar productName='mySpareParts Analyzer' canNavigate={false}>
        <BarNav position={BarNavPosition.Left}>
          <BarDivider orientation='vertical' />
          <BarNavLink to={[environmentSettings.basePath, `${environmentSettings.basePath}/`].includes(location.pathname) ? `/#reset` : '/'}>Get Started</BarNavLink>
          <BarDivider orientation='vertical' />
        </BarNav>
          {requestBarNav}
          {userBarNav}
        </Bar>
        <BannerContainer />
        <div className='container-fluid'>{this.props.children}</div>
      </div>
    </IdleTimer>
    );
  }
}
export default withRouter(connect(mapStateToProps)(LayoutComponent) as any);

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    userPermissions: store.userState.userPermissions
  };
}
